import { useEffect } from 'react'
import { useMap } from 'react-leaflet'
import L from 'leaflet'
import 'leaflet.heat'

const HeatmapLayer = ({ points }) => {
    console.log(points)
  const map = useMap()

  useEffect(() => {
    if (!points || points.length === 0) return

    const heatLayer = L.heatLayer(
      points.map(p => [p.lng, p.lat, p.weight || 1]),
      {
        radius: 25,
        blur: 10,
        maxZoom: 17
      }
    )

    heatLayer.addTo(map)

    return () => {
      map.removeLayer(heatLayer)
    }
  }, [points, map])

  return null
}

export default HeatmapLayer
